module.exports = __webpack_public_path__ + "img/s8.398eae5c.png";